import { useRequestsStorage } from '@client/adapters/store/requestsStoreAdapters';

export default useRequestsStorage;
